"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));
var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));
var _createObservers = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("createObservers");
var _listen = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("listen");
var _initializeCarousel = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("initializeCarousel");
var _goToElement = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("goToElement");
var _scrollScroller = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("scrollScroller");
var _syncronize = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("syncronize");
var _setArrowBtns = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("setArrowBtns");
var _setInertAttributes = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("setInertAttributes");
var _setPaginationIndicator = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("setPaginationIndicator");
class CarouselUtils {
  constructor(_ref) {
    var _options$slideGutterS;
    let {
      carouselEl,
      scrollerEl,
      paginationEl,
      slides,
      navBtnEls = {
        next: {},
        previous: {}
      },
      options
    } = _ref;
    /**
     * Sets the pagination indicator to the current slide
     */
    Object.defineProperty(this, _setPaginationIndicator, {
      value: _setPaginationIndicator2
    });
    /**
     * Sets the inert attribute on all slides that are not the current slide
     */
    Object.defineProperty(this, _setInertAttributes, {
      value: _setInertAttributes2
    });
    /**
     * Sets the control arrow buttons to disabled if the carousel is at the start or end
     */
    Object.defineProperty(this, _setArrowBtns, {
      value: _setArrowBtns2
    });
    /**
     * Syncronizes various elements of the carousel
     * 
     * add methods here to have them sync 
     * when scroller is scrolled
     */
    Object.defineProperty(this, _syncronize, {
      value: _syncronize2
    });
    /**
     * Scrolls the carousel in a specified direction by a specified distance
     * 
     * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward 
     * @param {number} distance - a number representing the number of slides to scroll
     */
    Object.defineProperty(this, _scrollScroller, {
      value: _scrollScroller2
    });
    /**
     * Scrolls the carousel to a specific child element
     * @param {*} param0 - an object containing the scrollport element and the child element to scroll to 
     */
    Object.defineProperty(this, _goToElement, {
      value: _goToElement2
    });
    /**
     * sets some intial settings for the carousel based on some of the options
     */
    Object.defineProperty(this, _initializeCarousel, {
      value: _initializeCarousel2
    });
    /**
     * sets listeners on the slide elements for the observer
     */
    Object.defineProperty(this, _listen, {
      value: _listen2
    });
    /**
     * adds an observer to the scroller element that we can use to 
     * determine which slide is intersecting
     */
    Object.defineProperty(this, _createObservers, {
      value: _createObservers2
    });
    // scrollend polyfill ========================
    // https://github.com/argyleink/scrollyfills
    const supported = ("onscrollend" in window);
    if (!supported) {
      const scrollendEvent = new Event('scrollend');
      const pointers = new Set();

      // Track if any pointer is active
      document.addEventListener('touchstart', e => {
        for (let touch of e.changedTouches) pointers.add(touch.identifier);
      }, {
        passive: true
      });
      document.addEventListener('touchend', e => {
        for (let touch of e.changedTouches) pointers.delete(touch.identifier);
      }, {
        passive: true
      });

      // Map of scroll-observed elements.
      let observed = new WeakMap();

      // Forward and observe calls to a native method.
      function observe(proto, method, handler) {
        let native = proto[method];
        proto[method] = function () {
          let args = Array.prototype.slice.apply(arguments, [0]);
          native.apply(this, args);
          args.unshift(native);
          handler.apply(this, args);
        };
      }
      function onAddListener(originalFn, type, handler, options) {
        // Polyfill scrollend event on any element for which the developer listens
        // to 'scrollend' explicitly or 'scroll' (so that adding a scrollend listener
        // from within a scroll listener works).
        if (type !== 'scroll' && type !== 'scrollend') return;
        let scrollport = this;
        let data = observed.get(scrollport);
        if (data === undefined) {
          let timeout = 0;
          data = {
            scrollListener: evt => {
              clearTimeout(timeout);
              timeout = setTimeout(() => {
                if (pointers.size) {
                  // if pointer(s) are down, wait longer
                  setTimeout(data.scrollListener, 100);
                } else {
                  // dispatch
                  scrollport.dispatchEvent(scrollendEvent);
                  timeout = 0;
                }
              }, 100);
            },
            listeners: 0 // Count of number of listeners.
          };
          originalFn.apply(scrollport, ['scroll', data.scrollListener]);
          observed.set(scrollport, data);
        }
        data.listeners++;
      }
      function onRemoveListener(originalFn, type, handler) {
        if (type !== 'scroll' && type !== 'scrollend') return;
        let scrollport = this;
        let data = observed.get(scrollport);

        // Mismatched addEventListener / removeEventListener
        // TODO: Should we explicitly track added listeners to prevent this?
        if (data === undefined) return;
        data[type]--;
        // If there are still listeners, nothing more to do.
        if (--data.listeners > 0) return;

        // Otherwise, remove the added listeners.
        originalFn.apply(scrollport, ['scroll', data.scrollListener]);
        observed.delete(scrollport);
      }
      observe(Element.prototype, 'addEventListener', onAddListener);
      observe(window, 'addEventListener', onAddListener);
      observe(document, 'addEventListener', onAddListener);
      observe(Element.prototype, 'removeEventListener', onRemoveListener);
      observe(window, 'removeEventListener', onRemoveListener);
      observe(document, 'removeEventListener', onRemoveListener);
    }
    // scrollend polyfill end
    this.carouselEl = carouselEl;
    this.scrollerEl = scrollerEl;
    this.paginationEl = paginationEl;
    this.slides = slides;
    this.currentIndex = 0;
    this.slideEls = [...scrollerEl.children];
    this.navBtnEls = navBtnEls;
    this.currentIntersecting = {};
    this.options = options;
    // setup autoplay interval
    if (options.autoplay) {
      var _options$delay;
      this.timer = null;
      this.timerInterval = (_options$delay = options === null || options === void 0 ? void 0 : options.delay) !== null && _options$delay !== void 0 ? _options$delay : 3500;
      this.startTimer();
    }
    this.slideGutterSize = (_options$slideGutterS = options === null || options === void 0 ? void 0 : options.slideGutterSize) !== null && _options$slideGutterS !== void 0 ? _options$slideGutterS : 25;
    this.showPagination = options === null || options === void 0 ? void 0 : options.showPagination;
    this.isInitialScroll = true;
    this.totalSlideEls = this.slideEls.length;
    this.totalSlides = Math.ceil(this.slides.length / this.options.cellsPerSlide);
    (0, _classPrivateFieldLooseBase2.default)(this, _createObservers)[_createObservers]();
    (0, _classPrivateFieldLooseBase2.default)(this, _initializeCarousel)[_initializeCarousel]();
    (0, _classPrivateFieldLooseBase2.default)(this, _listen)[_listen]();
  }
  /**
   * starts the autoplay timer
   */
  startTimer() {
    if (!this.timer) this.timer = setInterval(() => {
      this.determineScrollAction(1);
    }, this.timerInterval);
  }
  /**
   * clears the autoplay timer
   */
  clearTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }
  /**
   * checks to see if the scroller is moving to the
   * end or beginning, if so it makes the appropriate 
   * updates
   * 
   * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward
   */
  determineScrollAction(dir) {
    if (this.options.autoplay && this.timer !== null) this.clearTimer();
    // dir next slide - forward
    if (dir === 1) {
      if (this.currentIndex === this.totalSlides - 1) {
        if (this.options.wrapAround) {
          // reset scroll
          this.scrollerEl.style.scrollBehavior = 'auto';
          this.scrollerEl.scrollTo(0, 0);
          (0, _classPrivateFieldLooseBase2.default)(this, _scrollScroller)[_scrollScroller](dir);
          this.currentIndex = 0;
        }
      } else {
        (0, _classPrivateFieldLooseBase2.default)(this, _scrollScroller)[_scrollScroller](dir);
        this.currentIndex += 1;
      }
      // dir previous slide - backwards
    } else if (dir === -1) {
      if (this.currentIndex === 0) {
        if (this.options.wrapAround) {
          this.scrollerEl.style.scrollBehavior = 'auto';
          // scroll to the end
          this.scrollerEl.scrollTo(99999, 0);
          this.currentIndex = this.totalSlides - 1;
          (0, _classPrivateFieldLooseBase2.default)(this, _scrollScroller)[_scrollScroller](dir);
        }
      } else {
        (0, _classPrivateFieldLooseBase2.default)(this, _scrollScroller)[_scrollScroller](dir);
        this.currentIndex -= 1;
      }
    }
    if (this.options.autoplay && this.timer === null) this.startTimer();
  }
  /**
   * Navigates the carousel to a specific index
   * 
   * @param {number} index 
   * @returns void
   */
  navigateToIndex(index) {
    if (index === this.currentIndex) return;
    if (this.options.autoplay) this.clearTimer();
    let distance = index > this.currentIndex ? index - this.currentIndex : this.currentIndex - index;
    let direction = index > this.currentIndex ? 1 : -1;
    this.currentIndex = index;
    (0, _classPrivateFieldLooseBase2.default)(this, _scrollScroller)[_scrollScroller](direction, distance);
    if (this.options.autoplay) this.startTimer();
    (0, _classPrivateFieldLooseBase2.default)(this, _syncronize)[_syncronize]();
  }
  /**
   * Returns the current index of the carousel
   * 
   * @returns {number} - the current index of the carousel
   */
  getCurrentIndex() {
    return this.currentIndex;
  }
  /**
   * Handles the scrollend event - determines which slide is in view and updates the carousel
   * @returns void
   */
  handleScrollEnd() {
    if (this.timer === null && this.options.autoplay) this.startTimer();
    if (this.currentIntersecting.target) {
      const newIndex = Number.parseInt(this.currentIntersecting.target.getAttribute('data-index'), 10);

      // if not wrapping normal scroll behavior will work
      if (!this.options.wrapAround) {
        this.currentIndex = newIndex;
        (0, _classPrivateFieldLooseBase2.default)(this, _syncronize)[_syncronize]();
        return;
      }
      if (newIndex === 0) {
        this.currentIndex = this.slides.length - 1;
        (0, _classPrivateFieldLooseBase2.default)(this, _goToElement)[_goToElement]({
          scrollport: this.scrollerEl,
          element: this.slideEls[this.totalSlides]
        });
      } else if (newIndex === this.totalSlideEls - 1) {
        this.currentIndex = 0;
        (0, _classPrivateFieldLooseBase2.default)(this, _goToElement)[_goToElement]({
          scrollport: this.scrollerEl,
          element: this.slideEls[1]
        });
      } else {
        this.currentIndex = newIndex - 1;
      }
    }
    (0, _classPrivateFieldLooseBase2.default)(this, _syncronize)[_syncronize]();
  }
}
exports.default = CarouselUtils;
function _createObservers2() {
  this.carouselObserver = new IntersectionObserver(observations => {
    for (let observation of observations) {
      if (observation.isIntersecting) {
        // just cache the last slide to be intersecting
        this.currentIntersecting = observation;
      }
    }
  }, {
    root: this.scrollerEl,
    threshold: 0.8
  });
}
function _listen2() {
  for (let item of this.slideEls) this.carouselObserver.observe(item);
}
function _initializeCarousel2() {
  if (this.options.wrapAround) {
    // reset the horizonatl scroll for browers that remember it 
    this.scrollerEl.style.scrollBehavior = 'auto';
    this.scrollerEl.scrollTo(-9999, 0);
    /** 
     * since the last slide has been added to the beginning of the array
     * for infinite scrolling (wrapAround), scroll to the first slide of the set
     */
    (0, _classPrivateFieldLooseBase2.default)(this, _goToElement)[_goToElement]({
      scrollport: this.scrollerEl,
      element: this.scrollerEl.children[1]
    });
  } else if (this.options.showControls) {
    this.navBtnEls.previous.setAttribute('disabled', true);
    (0, _classPrivateFieldLooseBase2.default)(this, _syncronize)[_syncronize]();
  } else {
    (0, _classPrivateFieldLooseBase2.default)(this, _setInertAttributes)[_setInertAttributes]();
  }
  if (this.totalSlides === 1) {
    this.slideEls[0].removeAttribute('inert');
  }
}
function _goToElement2(_ref2) {
  let {
    scrollport,
    element
  } = _ref2;
  const slideOverlap = this.slideGutterSize * 2 / 100;
  scrollport.style.scrollBehavior = 'auto';
  scrollport.scrollTo(Math.abs(scrollport.offsetLeft - element.offsetLeft + element.clientWidth * slideOverlap), 0);
}
function _scrollScroller2(dir) {
  let distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  this.scrollerEl.style.scrollBehavior = 'smooth';
  this.scrollerEl.scrollBy({
    left: this.scrollerEl.clientWidth * ((100 - this.slideGutterSize * 2) / 100) * distance * dir,
    top: 0,
    behavior: 'smooth'
  });
}
function _syncronize2() {
  (0, _classPrivateFieldLooseBase2.default)(this, _setInertAttributes)[_setInertAttributes]();
  if (this.showPagination) (0, _classPrivateFieldLooseBase2.default)(this, _setPaginationIndicator)[_setPaginationIndicator]();
  if (!this.options.wrapAround) (0, _classPrivateFieldLooseBase2.default)(this, _setArrowBtns)[_setArrowBtns]();
}
function _setArrowBtns2() {
  if (this.navBtnEls.previous && this.navBtnEls.next) {
    this.navBtnEls.previous.removeAttribute('disabled');
    this.navBtnEls.next.removeAttribute('disabled');
    if (this.currentIndex === 0) this.navBtnEls.previous.toggleAttribute('disabled');
    if (this.currentIndex === this.slideEls.length - 1) this.navBtnEls.next.toggleAttribute('disabled');
  }
}
function _setInertAttributes2() {
  const compareTo = this.options.wrapAround ? this.currentIndex + 1 : this.currentIndex;
  if (this.slideEls.length === 1) {
    this.slideEls[0].removeAttribute('inert');
  } else {
    this.slideEls.forEach((slide, index) => {
      // currentIndex + 1 to accomodate for the extra slide at the 
      // start of the display list
      slide.toggleAttribute('inert', !(index === compareTo));
    });
  }
}
function _setPaginationIndicator2() {
  [...this.paginationEl.children].forEach((item, index) => {
    if (index === this.currentIndex) {
      item.setAttribute('data-current', 'true');
    } else {
      item.setAttribute('data-current', 'false');
    }
  });
}